"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechHistoryItemResponseModelSource = void 0;
exports.SpeechHistoryItemResponseModelSource = {
    Tts: "TTS",
    Sts: "STS",
    Projects: "Projects",
    Pd: "PD",
    An: "AN",
    Dubbing: "Dubbing",
    PlayApi: "PlayAPI",
    ConvAi: "ConvAI",
};
